export default "__VITE_ASSET__BSJ59VL7__"